import React, { useContext, useState, useEffect, useCallback } from "react";
import useLocalStorage from "../hooks/useLocalStorage";
import { useContacts } from "./ContactsProvider";
import { useSocket } from "./SocketProvider";
import config from "../config.json";
import toast, { Toaster } from "react-hot-toast";

const ConversationsContext = React.createContext();

export function useConversations() {
  return useContext(ConversationsContext);
}

export function ConversationsProvider({ id, children }) {
  const [conversations, setConversations] = useLocalStorage(
    "conversations",
    []
  );
  const [refresh, setRefresh] = useState(false);

  const [quickResponses, setQuickResponses] = useLocalStorage(
    "quick-responses",
    []
  );
  const [selectedConversationIndex, setSelectedConversationIndex] =
    useState(-1);
  const { contacts, setRefreshContact } = useContacts();
  const socket = useSocket();

  function createConversation(
    chatid,
    recipients,
    chatName,
    messages,
    isGroup,
    notification
  ) {
    setConversations((prevConversations) => {
      // Check if a conversation with the same chatid already exists
      const existingConversationIndex = prevConversations.findIndex(
        (conversation) => conversation.chatid === chatid
      );

      // If an existing conversation was found, update the messages to an empty array
      if (existingConversationIndex !== -1) {
        const updatedConversations = [...prevConversations];
        updatedConversations[existingConversationIndex] = {
          ...updatedConversations[existingConversationIndex],
          chatName: chatName,
          recipients: recipients,
          notification: notification,
          isGroup: isGroup,
          messages: [],
        };
        return updatedConversations;
      }

      // Otherwise, add the new conversation to the end of the array
      return [
        ...prevConversations,
        { chatid, chatName, recipients, messages, notification, isGroup },
      ];
    });
  }

  const addMessageToConversation = useCallback(
    ({
      chatid,
      text,
      sender,
      date,
      type,
      byteArray,
      notification,
      messageid,
    }) => {
      setConversations((prevConversations) => {
        let madeChange = false;

        const newMessage = { sender, text, date, type, byteArray, messageid };

        const newConversations = prevConversations.map((conversation) => {
          if (conversation.chatid === chatid) {
            // Check if message with the same messageid already exists
            const isUniqueMessage = !conversation.messages.some(
              (msg) => msg.messageid === messageid
            );

            if (isUniqueMessage) {
              madeChange = true;

              return {
                ...conversation,
                messageid: messageid,
                messages: [...conversation.messages, newMessage],
                notification:
                  notification === true
                    ? 1 + conversation.notification
                    : conversation.notification,
              };
            }
          }

          return conversation;
        });

        if (madeChange) {
          return newConversations;
        }
      });
    },
    [setConversations]
  );

  useEffect(() => {
    if (socket == null) return;
    socket.onmessage = function (event) {
      //PING PONG SERVER TO MAINTAIN CONNECTION
      if (event.data === "PING") {
        socket.send("PONG");
      } else if (event.data === "UPDATED") {
        console.log("REFRESHING EVERYTHING");
        setRefreshContact((prevRefresh) => !prevRefresh);
        setRefresh((prevRefresh) => !prevRefresh);
      } else {
        const json = JSON.parse(event.data);
        console.group("Message recieved from Server");
        console.log(json);

        console.groupEnd();

        var chatid = json.message.chat;
        var sender = json.message.sender;
        var text = json.message.content;
        var date = json.message.datetime;
        var notification = json.notification;
        var type = json.message.type;
        var byteArray = json.message.bytearray;
        var messageid = json.message.id;

        addMessageToConversation({
          chatid,
          text,
          sender,
          date,
          type,
          byteArray,
          notification,
          messageid,
        });
      }

      //SET UP SYSTEM FOR NOTIFICATION
    };
    //socket.on("receive-message", addMessageToConversation);
    //return () => socket.off("receive-message");
  }, [socket, addMessageToConversation]);

  useEffect(() => {
    (async () => {
      try {
        console.log("Trying to fetch information from ");
        const allChatMessages = await fetch(
          config.domainName +
            ":" +
            config.port +
            "/user/allchats/?messages=100&id=" +
            id,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
          }
        );
        const allQuickResponses = await fetch(
          config.domainName + ":" + config.port + "/user/responses?id=" + id,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
          }
        );
        const content2 = await allQuickResponses.json();
        if (content2.responses !== null) {
          setQuickResponses(content2.responses);
        } else {
          setQuickResponses([]);
        }
        const content = await allChatMessages.json();

        if (content) {
          console.log(content);
          setConversations([]);
          content.chats.forEach((chat) => {
            const chatName = chat.chat.name;
            createConversation(
              chat.chat.id,
              chat.chat.members,
              chatName,
              [],
              chat.isgroup,
              chat.numnew
            );
            if (chat.messages !== null) {
              chat.messages.forEach((message) => {
                addMessageToConversation({
                  chatid: chat.chat.id,
                  text: message.content,
                  sender: message.sender,
                  date: message.datetime,
                  type: message.type,
                  byteArray: message.bytearray,
                  notification: false,
                  messageid: message.id,
                });
              });
            }
          });
        }
      } catch (error) {
        console.log("Server can not be connected");
      }
    })();
  }, [id, refresh]);

  function sendMessage(chatid, text, date, type, bytearray = null) {
    console.group("I GOT CALLED FOR THE FOLLOWING MESSAGE");

    //console.log(bytearray);

    // var base64 = btoa(
    //   new Uint8Array(bytearray).reduce(
    //     (data, byte) => data + String.fromCharCode(byte),
    //     ""
    //   )
    // );
    // console.log(base64);

    // Assuming you have an audio blob named 'audioBlob'

    // const reader = new FileReader();

    // reader.onload = function () {
    //   const bytearray = new Uint8Array(reader.result);

    //   var base64 = btoa(
    //     new Uint8Array(bytearray).reduce(
    //       (data, byte) => data + String.fromCharCode(byte),
    //       ""
    //     )
    //   );
    //   var jsonObj = JSON.stringify({
    //     chat: chatid,
    //     content: text,
    //     datetime: date,
    //     type: type,
    //     bytearray: base64,
    //   });
    //   console.log(jsonObj);
    //   socket.send(jsonObj);

    //   addMessageToConversation({
    //     chatid,
    //     text,
    //     sender: id,
    //     date,
    //     type,
    //     byteArray: base64,
    //   });
    //   console.log(base64);
    // };
    // reader.readAsArrayBuffer(bytearray);

    //console.log(audioArrayBase64);

    var jsonObj = JSON.stringify({
      chat: chatid,
      content: text,
      datetime: date,
      type: type,
      bytearray: null,
    });
    console.log(jsonObj);
    socket.send(jsonObj);

    // addMessageToConversation({
    //   chatid,
    //   text,
    //   sender: id,
    //   date,
    //   type,
    //   byteArray: null,
    // });
    console.groupEnd();

    //socket.emit("send-message", { recipients, text });
  }

  useEffect(() => {
    if (selectedConversationIndex !== -1) {
      conversations[selectedConversationIndex].notification = 0;
      console.log(
        "SETTING OPEN CONVERSATION TO: " +
          conversations[selectedConversationIndex].chatid
      );
      socket.send(conversations[selectedConversationIndex].chatid);
    } else {
      if (socket) {
        socket.send("-1");
      }
    }
  }, [selectedConversationIndex]);

  const formattedConversations =
    conversations == []
      ? []
      : conversations.map((conversation, index) => {
          const recipients = conversation.recipients.map((recipient) => {
            const contact = contacts.find((contact) => {
              return contact.id === recipient;
            });
            const name = (contact && contact.name) || recipient;
            return { id: recipient, name };
          });

          const messages = conversation.messages.map((message) => {
            const contact = contacts.find((contact) => {
              return contact.id === message.sender;
            });
            const name = (contact && contact.name) || message.sender;
            const fromMe = id === message.sender;
            return { ...message, senderName: name, fromMe };
          });

          const selected = index === selectedConversationIndex;
          return { ...conversation, messages, recipients, selected };
        });

  const value = {
    conversations: formattedConversations,
    selectedConversation: formattedConversations[selectedConversationIndex],
    sendMessage,
    selectConversationIndex: setSelectedConversationIndex,
    createConversation,
    quickResponses,
  };

  return (
    <ConversationsContext.Provider value={value}>
      <Toaster />
      {children}
    </ConversationsContext.Provider>
  );
}
